import {
  AccountAccessFlowProcessingReasonSchema,
  AccountAccessFlowStatusSchema,
} from '../../schemas/shared';
import type { CheckoutApiAccountAccess } from '../../types/CheckoutApiAccountAccess';
import type { GlobalApiAccountAccess } from '../../types/GlobalApiAccountAccess';

export const shouldPollAccountAccess = (
  accountAccess: CheckoutApiAccountAccess | GlobalApiAccountAccess | undefined
) =>
  accountAccess?.accountAccessFlow?.status ===
    AccountAccessFlowStatusSchema.enum.PROCESSING &&
  (
    [
      AccountAccessFlowProcessingReasonSchema.enum.AWAITING_REDIRECT_URL,
      AccountAccessFlowProcessingReasonSchema.enum
        .AWAITING_DECOUPLED_AUTHORISATION,
    ] as string[]
  ).includes(accountAccess.accountAccessFlow.details.reason);
